/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import Store from 'state/Store';

import { REQUEST_STATES } from 'state/requests/RequestStatusReducer';

export const isRequested = (requestState) => {
  const { requestStatus } = Store.getState();
  return requestStatus[requestState] === REQUEST_STATES.requested;
};

export const isReceived = (requestState) => {
  const { requestStatus } = Store.getState();
  return requestStatus[requestState] === REQUEST_STATES.received;
};

export const isError = (requestState) => {
  const { requestStatus } = Store.getState();
  return requestStatus[requestState] === REQUEST_STATES.error;
};
